import { useState } from "react";
import { useField } from "formik";
import { FiEye, FiEyeOff } from "react-icons/fi";
import PhoneInput from "react-phone-input-2";

const AccountField = ({ label, optional, help, type = "text", options = [], ...props }) => {
	const [field, meta, helpers] = useField(props.name);
	const [visible, setVisible] = useState(false);
	const invalid = Boolean(meta.touched && meta.error);
	const id = props.id || props.name;
	const inputProps = {
		...field,
		...props,
		id,
		"aria-invalid": invalid,
		"aria-describedby":
			[help && `${id}-help`, invalid && `${id}-error`].filter(Boolean).join(" ") || undefined,
	};
	const input =
		type === "phone" ? (
			<PhoneInput
				country="zw"
				preferredCountries={["zw", "za"]}
				countryCodeEditable={false}
				enableSearch
				disableSearchIcon
				specialLabel=""
				value={field.value}
				disabled={props.disabled}
				placeholder={props.placeholder}
				onChange={(value) => helpers.setValue(value ? `+${value}` : "")}
				onBlur={() => helpers.setTouched(true)}
				inputProps={{
					...props,
					id,
					"aria-invalid": invalid,
					"aria-describedby": inputProps["aria-describedby"],
				}}
			/>
		) : type === "select" ? (
			<select {...inputProps}>
				<option value="">Select an option</option>
				{options.map((option) => (
					<option key={option.value} value={option.value}>
						{option.label}
					</option>
				))}
			</select>
		) : (
			<input {...inputProps} type={type === "password" && visible ? "text" : type} />
		);
	return (
		<div className="account-field">
			<label htmlFor={id}>
				{label}
				{optional && <span>(optional)</span>}
			</label>
			{type === "password" ? (
				<div className="account-password-input">
					{input}
					<button
						type="button"
						className="account-password-toggle"
						aria-label={`${visible ? "Hide" : "Show"} ${label.toLowerCase()}`}
						aria-pressed={visible}
						onClick={() => setVisible(!visible)}
					>
						{visible ? <FiEyeOff aria-hidden="true" /> : <FiEye aria-hidden="true" />}
					</button>
				</div>
			) : (
				input
			)}
			{help && (
				<p id={`${id}-help`} className="account-helper">
					{help}
				</p>
			)}
			{invalid && (
				<p id={`${id}-error`} className="account-field-error" role="alert">
					{meta.error}
				</p>
			)}
		</div>
	);
};

export default AccountField;
